import Link from "next/link";
import Tag from "../Tag";
import { useState } from "react";
import Pagination from "../Pagination";
import formatDate from "@/utils/blog/formatDate";
import {
  Box,
  Button,
  chakra,
  Container,
  Flex,
  Grid,
  Heading,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { ChevronRightIcon, SearchIcon } from "@chakra-ui/icons";
import { LinkButton } from "../../shared/generic";
import OptimizedImage from "../../shared/OptimizedImage";

export default function ListLayout({ posts, title, initialDisplayPosts = [], pagination }) {
  const [searchValue, setSearchValue] = useState("");
  const filteredBlogPosts = posts.filter((frontMatter) => {
    const searchContent = frontMatter.title + frontMatter.summary + frontMatter.tags.join(" ");
    return searchContent.toLowerCase().includes(searchValue.toLowerCase());
  });

  // If initialDisplayPosts exist, display it if no searchValue is specified
  const displayPosts =
    initialDisplayPosts.length > 0 && !searchValue ? initialDisplayPosts : filteredBlogPosts;

  return (
    <>
      <Box minH="85vh">
        <Box mt={10}>
          <chakra.h1
            textAlign="center"
            fontSize={{ base: "5xl", md: "7xl" }}
            textStyle="pageHeader"
          >
            {title}
          </chakra.h1>
        </Box>
        <Container maxW="container.sm" mt={4}>
          <InputGroup maxW={{ md: "40em" }}>
            <InputLeftElement pointerEvents="none">
              <SearchIcon />
            </InputLeftElement>
            <Input
              aria-label="Search articles"
              type="search"
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Search articles"
            />
          </InputGroup>
        </Container>
        <Flex mt={10} gap={10} flexDir="column">
          {!filteredBlogPosts.length && "No posts found."}
          {displayPosts.map((frontMatter) => {
            const { slug, date, title, summary, tags, img } = frontMatter;
            return (
              <Box key={slug} py={4}>
                <Grid
                  as="article"
                  templateColumns={{ base: "1fr", md: "1fr 2fr" }}
                  gap={6}
                  alignItems="stretch"
                >
                  <Box sx={{ aspectRatio: "4 / 3" }} pos="relative" maxW="100%">
                    <OptimizedImage
                      src={img}
                      alt="Image for blog post"
                      objectFit="cover"
                      layout="fill"
                      borderRadius="lg"
                    />
                  </Box>
                  <Flex direction="column">
                    <Heading
                      cursor="pointer"
                      as="h2"
                      fontSize="3xl"
                      fontFamily="heading"
                      fontWeight="700"
                    >
                      <Link href={`/blog/${slug}`} legacyBehavior>
                        {title}
                      </Link>
                    </Heading>
                    <Text mt={3}>
                      <chakra.time dateTime={date}>{formatDate(date)}</chakra.time>
                    </Text>
                    <Flex flexWrap="wrap">
                      {tags.map((tag) => (
                        <Tag key={tag} text={tag} />
                      ))}
                    </Flex>
                    <Box mt={3}>{summary}</Box>
                    <Spacer />
                  </Flex>
                </Grid>
              </Box>
            );
          })}
        </Flex>
      </Box>
      {pagination && pagination.totalPages > 1 && !searchValue && (
        <Pagination currentPage={pagination.currentPage} totalPages={pagination.totalPages} />
      )}
    </>
  );
}
